<template>
	<div>		
		<el-row :gutter="20">
		  <el-col :span="8" v-for="(item,index) in proxyList" :key="index">
			  <el-card class="box-card" >
			    <div slot="header" class="clearfix">
			      <span>{{item.nickname || '代理商'}}</span>
			      <el-button style="float: right; padding: 3px 0" type="text" @click="toDetail(item.id)">详情</el-button>
			    </div>
			    <div class="text item">手机号: {{item.phone_number}}</div>
			    <div class="text item">余额: {{item.money}}</div>
			    <div class="text item">累计销售金额: {{item.ljmoney}}</div>
				<div class="text item">最后成单时间: {{item.the_end_order_time}}</div>
			  </el-card>
		  </el-col>	  
		</el-row>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				search: {
					page: 1,
					per_page: 10,
					total: 0,
				},
				proxyList: [],
				
			}
		},
		methods: {
			getList() {
				this.$axios.get('admin-get-dls-users', this.search).then(res => {
					if (!res.code) {
						this.$message.error('列表获取失败')
						return
					}
					this.proxyList = res.data;
					// this.search.total = res.data.total;
				});
			},
			toDetail(id) {
				this.$router.push({name: '代理商详情',params: {id: id}})
			}
		},
		mounted() {
			this.getList()
		}
	}
</script>

<style scoped lang="scss">
	.table{
		/deep/ .el-table__expanded-cell{
			background-color: #f7f7f7 !important;
		}	
	}
	
	.el-col{
		margin-top: 16px;
	}
	
</style>
